import { CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router';
import { Button } from '@/components/ui/button';
import { AuthShell } from './AuthShell';

export default function AccountVerifySuccess() {
  return (
    <AuthShell title="Email verified">
      <div className="p-6 flex flex-col items-center text-center">
        <div className="w-12 h-12 rounded-full bg-sev-4/15 flex items-center justify-center text-sev-4 mb-4">
          <CheckCircle2 className="w-5 h-5" />
        </div>
        <p className="text-sm text-foreground mb-4">Thanks for verifying your email.</p>
        <Button asChild className="w-full">
          <Link to="/signin">Sign in</Link>
        </Button>
      </div>
    </AuthShell>
  );
}
